import { schemes, zSchema } from "@zeal/common";

export const getBankAccountRequestSchema = zSchema.object({
  companyID: zSchema.string(),
  id: schemes.mongoOrUuid().optional(), // Accepts both MongoDB ObjectId (workers/contractors) and UUID (customer accounts)
  bankAccountID: zSchema.string().optional(),
});

export type TGetBankAccountArgs = zSchema.infer<
  typeof getBankAccountRequestSchema
>;

export const getBankAccountResponseSchema = zSchema.array(
  zSchema.object({
    account_number: schemes.bankAccountNumber().optional(),
    bankAccountID: schemes.mongoOrUuid(),
    companyID: schemes.companyID(),
    id: schemes.mongoObjectId(),
    institution_name: zSchema.string().optional(),
    is_primary: zSchema.boolean(),
    routing_number: schemes.routingNumber().optional(),
    type: schemes.bankAccountType().optional(),
    payment_destination_id: schemes.uuid().optional(),
  })
);

// Export TBankAccountObject as the array element type for use in other files (needed for invoice payments)
export type TBankAccountObject = zSchema.infer<
  typeof getBankAccountResponseSchema
>[number];

export type TGetBankAccountResponse = zSchema.infer<
  typeof getBankAccountResponseSchema
>;
